module.exports = __webpack_public_path__ + "img/tarj3-2.3cca64a4.png";